<template>
  <QuestionResponseBars
    :display-data="displayData"
    :assigned-colors="assignedColors"
  />
</template>


<script>
import QuestionResponseBars from './QuestionResponseBars.vue';


export default {
  name: 'ComponentName',
  components: { QuestionResponseBars },
  props: ['question', 'assignedColors'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    choices() {
      return this.question.choices;
    },
    responses() {
      return this.question.responses;
    },
    count() {
      return this.responses ? this.responses.length : 0;
    },
    formatted() {
      if (!this.responses) return {};
      const data = {};

      this.responses.forEach(r => {
        const res = r.response;
        const choices = typeof res === 'string' ? [res] : res;

        choices.forEach(c => {
          if (!data[c]) data[c] = { n: 0, names: [] };
          data[c].n++;
          data[c].names.push(r.name);
        });
      });
      return data;
    },
    displayData() {
      return Object.keys(this.formatted).map(choice => {
        const data = { ...this.formatted[choice] };

        data.pct = (data.n / this.count) * 100;
        data.choice = choice;
        return data;
      });
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
